import { useTranslation } from 'react-i18next';
import './inboxList.less';
import { useEffect, useState } from 'react';
import { Button, Collapse } from 'antd';
import { useInboxChangeShowndate, useInboxQuery } from 'all-in-one-shared-api';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { isLocaleEnglish } from 'utils';
import { changeDataFun } from '../../../utils/changeDataFun';
import { Markdown } from 'components';

const { Panel } = Collapse;
export const InboxList = (props: { searchTerm: string; onChangeYd: () => void }) => {
  const [randoms, setRandoms] = useState(0);
  const [viewMore, setViewMore] = useState({
    page: 0,
    pageSize: 5,
  });
  const { keycloak } = useKeycloak();
  const { i18n, t } = useTranslation();
  const [moreExist, setMoreExist] = useState(true);
  const [clickMore, setClickMore] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  interface LifeInboxResponse {
    id: number;
    messageCategory: string;
    policyNo: string;
    messageTitleEn: string;
    messageTitleZh: string;
    message: string;
    message_zh: string;
    messagePriority: number;
    effectiveDate: string;
    expiryDate: string;
    createDate: string;
    createUser: string;
    loginId: string;
    clientKey: string;
    buId: string;
    shownDate?: string;
    messageIcon?: string;
    categoryTc?: string;
    categoryEn?: string;
  }
  const {
    shouldFetch,
    data,
    error: inboxError,
  } = useInboxQuery('useLifeInbox' + randoms, keycloak.token as string, searchTerm, viewMore.page, viewMore.pageSize);
  /* eslint-disable */
  useEffect(() => {
    setRandoms(Math.random());
    shouldFetch(true);
  }, [keycloak.token]);
  const [expend, setExpend] = useState({
    activeId: '',
    bool: false,
  });
  useEffect(() => {
    setViewMore({
      page: 0,
      pageSize: 5,
    });
    setSearchTerm(props.searchTerm);
    setRandoms(Math.random());
    shouldFetch(true);
  }, [props.searchTerm]);
  useEffect(() => {
    if (data && Array.isArray(data) && clickMore) {
      setClickMore(false);
      shouldFetch(false);
      setList(list.concat(data)); //拼接
    } else if (data && Array.isArray(data) && !clickMore) {
      setClickMore(false);
      shouldFetch(false);
      setList(data); //不拼接
    } else if (inboxError) {
      setMoreExist(false);
      setClickMore(false);
    }

    if (data && data?.length < 5) {
      setMoreExist(false);
    } else if (data?.length == 5) {
      setMoreExist(true);
    }
  }, [data, inboxError]);
  const [activeId, setActiveId] = useState(0);
  useEffect(() => {
    if (activeId) {
      setRandoms(Math.random());
      changeShownFetch(true);
    }
  }, [activeId]);
  const {
    shouldFetch: changeShownFetch,
    data: changeShownData,
    error: changeShownError,
  } = useInboxChangeShowndate('useInboxChangeShowndate' + randoms, keycloak.token as string, activeId + '');
  useEffect(() => {
    console.log(changeShownData, changeShownError, 'qing');
    if (changeShownData) {
      const s = new Date().getTime();
      //   setTimeTsp(s);
      setList(
        list.map((d) => {
          if (d.id === activeId) {
            d.shownDate = new Date() + '';
          }
          return { ...d };
        }),
      );
    }
    props.onChangeYd();
  }, [changeShownData, changeShownError]);
  /* eslint-enable */

  const [list, setList] = useState((): LifeInboxResponse[] => []);
  const [expendKeys, setExpendKeys] = useState((): string[] => []);
  return (
    <div className="Inbox_list_container">
      <span className="last_days">{t('life.inbox.Last180Days')}</span>

      <div className="list_wrapper">
        <Collapse
          expandIconPosition="end"
          activeKey={expendKeys}
          onChange={(e) => {
            console.log(e);
            const extr = (e as string[]).find((d) => !expendKeys.includes(d)); // 选择
            // const extr1 = (expendKeys as string[]).find((d) => !e.includes(d)); // 取消
            setExpendKeys(e as string[]);
            if (extr) {
              setExpend({
                ...expend,
                activeId: extr as string,
                bool: true,
              });
              // 查看是否是未读
              const find = list.find((d) => d.id + '' === extr);

              if (find && !find.shownDate) {
                setActiveId(find.id);
              }
            } else {
              setExpend({
                ...expend,
                activeId: '',
                bool: false,
              });
            }
          }}
        >
          {list.map((item) => {
            return (
              <Panel
                className={[
                  !item.shownDate ? 'weidu site-collapse-custom-panel' : 'site-collapse-custom-panel',
                  expendKeys.includes(item.id + '') ? 'active' : 'disactive',
                  // item.id + '' === expend.activeId && expend.bool ? 'active' : 'disactive',
                ].join(' ')}
                header={
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className="headers_wd">
                      {isLocaleEnglish(i18n.language) ? item.categoryEn : item.categoryTc}
                    </span>
                    <span className="headers_info">
                      {isLocaleEnglish(i18n.language) ? item.messageTitleEn : item.messageTitleZh}
                    </span>
                  </div>
                }
                extra={isLocaleEnglish(i18n.language) ? item.createDate : changeDataFun(item.createDate)}
                key={item.id}
              >
                <Markdown>{isLocaleEnglish(i18n.language) ? item.message : item.message_zh}</Markdown>
              </Panel>
            );
          })}
        </Collapse>
      </div>

      <div className="list_viewMore">
        {moreExist && (
          <Button
            onClick={() => {
              setViewMore({
                ...viewMore,
                page: viewMore.page + 1,
              });
              setClickMore(true);
              setRandoms(Math.random());
              shouldFetch(true);
            }}
            type="default"
          >
            {t('life.inbox.viewMore')}
          </Button>
        )}
      </div>
    </div>
  );
};
